import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ScreeningService } from 'src/app/services/screening.service';
import { Subject, timer } from 'rxjs';
import { debounce, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.less']
})
export class TextInputComponent implements OnInit {
  @Input() property : string;
  @Input() model : any;
  @Input() type : string;
  @Input() label : string;
  @Output() modelChanged = new Subject<any>();
  @ViewChild("inputs", { static: true }) el : ElementRef;
  // ngAfterViewInit(): void {
  //   this.el.nativeElement.focus();
  // }
  constructor(private screeningSrv : ScreeningService) {
    this.modelChanged.pipe(debounce(()=> timer(3000)), distinctUntilChanged());
   
   }

  ngOnInit() {
    this.el.nativeElement.focus();
  }

  

  changes(newName) {
    this.model = newName;
    // console.log(this.model);
    this.modelChanged.next({
      name: this.property,
      value: this.model
    })
  }
}
